import ListRow from './ListRow';

import { useAppSelector } from '@shared/model';
import { selectTemplates } from '@entities/template';
import { listStyle, messageStyle } from './TemplateList.tailwind';

const TemplateList = () => {
  const templates = useAppSelector(selectTemplates);

  return (
    <>
      {templates.length ? (
        <ul className={listStyle}>
          {templates.map(template => (
            <ListRow key={template.id} {...template} />
          ))}
        </ul>
      ) : (
        <p className={messageStyle}>There are no selected Templates*</p>
      )}
    </>
  );
};

export default TemplateList;
